import React from "react";
import Agent from "./agent.jsx";
export const getServicesByGroups = async (barbershopName) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  return await requests.getAtt(
    `/serviceGroup/GetServiceGroupsByName?barbershopName=${barbershopName}`,
    null,
    null
  );
};
